import React, { useCallback, useEffect, useState } from "react";

import { useWaitlist } from "contexts/waitlist";
import "./waitlistModal.scss";

const WaitlistModal = () => {
  const [email, setEmail] = useState("");
  const {
    state: { status, modalOpen },
    submit,
    closeModal,
  } = useWaitlist();

  // Close on Escape
  useEffect(() => {
    if (!modalOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") closeModal();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [modalOpen, closeModal]);

  // Lock body scroll when open
  useEffect(() => {
    if (modalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [modalOpen]);

  // Reset local email when modal opens fresh
  useEffect(() => {
    if (modalOpen) setEmail("");
  }, [modalOpen]);

  const handleBackdrop = useCallback(
    (e) => {
      if (e.target === e.currentTarget) closeModal();
    },
    [closeModal],
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    submit(email);
  };

  if (!modalOpen) return null;

  return (
    <div
      className="waitlist-modal-backdrop"
      onClick={handleBackdrop}
      role="dialog"
      aria-modal="true"
      aria-label="Join the waitlist"
    >
      <div className="waitlist-modal">
        <button
          className="waitlist-modal-close"
          onClick={closeModal}
          aria-label="Close"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          >
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>

        {status === "success" ? (
          <div className="waitlist-modal-success">
            <span className="waitlist-modal-check">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </span>
            <h3>You're on the list.</h3>
            <p>We'll be in touch.</p>
          </div>
        ) : (
          <>
            <h3 className="waitlist-modal-heading">
              Get early access to NextFlip
            </h3>
            <p className="waitlist-modal-sub">
              Be first in line when we go live.
            </p>
            <form className="waitlist-modal-form" onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="you@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                aria-label="Email address"
              />
              <button type="submit" disabled={status === "loading"}>
                {status === "loading" ? "Submitting\u2026" : "Join Waitlist"}
              </button>
            </form>
            {status === "error" && (
              <span className="waitlist-modal-error">
                Something went wrong. Please try again.
              </span>
            )}
            <span className="waitlist-modal-note">
              Free during beta. No credit card required.
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default WaitlistModal;
